import React from "react";
import { Grid } from "@mui/material";

export default function FormFullWidthContainer({
  hasAdditionalTopMargin,
  children,
  container = true,
}: {
  hasAdditionalTopMargin?: boolean;
  container?: boolean;
  children: React.ReactNode;
}): React.JSX.Element {
  const className = hasAdditionalTopMargin ? "scd-section-pusher-lg" : "";
  return (
    <Grid
      container={container}
      size={{ xs: 12, md: 12, lg: 12 }}
      className={className}
    >
      {children}
    </Grid>
  );
}
